import Vue from 'vue';
import VTooltip from 'v-tooltip';
import InfiniteLoading from 'vue-infinite-loading';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as components from './components';

export default (VueInstance = Vue) => {
  VueInstance.use(VTooltip, {
    defaultHtml: false,
  });
  VueInstance.use(InfiniteLoading, {});
  VueInstance.use(ElementUI);
  Object.keys(components).forEach((name) => {
    VueInstance.component(name, components[name]);
  });
};
